<template>
  <ul class="list-group">
    <slot></slot>
  </ul>
</template>
<script>
export default {
  name: 'bs-list-group',
  props: {}
}
</script>



// WEBPACK FOOTER //
// src/components/list-group/ListGroup.vue?217dd243